<!-- @format -->
<template>
  <div class="detail-page">
    <div class="back-btn" @click="closeDialog">
      <i class="el-icon-arrow-left"></i> 返回
    </div>
    <!-- 订单信息 -->
    <div class="detail-card">
      <div class="card-title">
        <span class="title-bar"></span>
        订单信息
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="订单编号">{{ viewData.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ viewData.statusName }}</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ viewData.createTime }}</el-descriptions-item>
      </el-descriptions>
    </div>

    <!-- 产品信息 -->
    <div class="detail-card">
      <div class="card-title">
        <span class="title-bar"></span>
        产品信息
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="产品名称">{{ viewData.cpmc }}</el-descriptions-item>
        <el-descriptions-item label="贷款额度">{{ viewData.dkedxx }}～{{ viewData.dkedsx }}万元</el-descriptions-item>
        <el-descriptions-item label="贷款期限">{{ viewData.dkqxxx }}～{{ viewData.dkqxsx }}月</el-descriptions-item>
        <el-descriptions-item label="年化利率">{{ viewData.zdnhlv }}%～{{ viewData.zgnhlv }}%</el-descriptions-item>
        <el-descriptions-item label="担保方式">{{ viewData.dbfsm }}</el-descriptions-item>
        <el-descriptions-item label="贷款类型">{{ viewData.dklxm }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ viewData.khjl }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ viewData.lxrdh }}</el-descriptions-item>
        <el-descriptions-item label="所属机构">{{ viewData.jrjgmg }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 进度条 + 申请信息 (type==1 详情) -->
    <template v-if="type === 1">
      <!-- 进度条 -->
      <div v-if="viewData.status != 0" class="progress-card">
        <div class="progress-steps">
          <!-- 节点 -->
          <div
            v-for="(step, idx) in progressSteps"
            :key="idx"
            class="progress-step"
          >
            <div class="step-left">
              <div
                class="step-dot"
                :class="{
                  done: step.status === 'done',
                  current: step.status === 'current',
                  failed: step.status === 'failed',
                }"
              >
                <i v-if="step.status === 'done'" class="el-icon-check"></i>
                <i v-else-if="step.status === 'failed'" class="el-icon-close"></i>
              </div>
              <div
                class="step-label"
                :class="{
                  done: step.status === 'done',
                  current: step.status === 'current',
                  failed: step.status === 'failed',
                }"
              >
                {{ step.label }}
              </div>
            </div>
            <!-- 连接线（最后一个节点不显示） -->
            <div
              v-if="idx < progressSteps.length - 1"
              class="step-line"
              :class="{ done: step.status === 'done' }"
            ></div>
          </div>
        </div>
      </div>

      <div class="detail-card">
        <div class="card-title">
          <span class="title-bar"></span>
          申请信息
        </div>
        <el-descriptions :column="3" border>
          <el-descriptions-item label="申请企业">{{ viewData.qymc }}</el-descriptions-item>
          <el-descriptions-item label="贷款额度(万元)">{{ viewData.dked }}</el-descriptions-item>
          <el-descriptions-item label="贷款期限(月)">{{ viewData.dkqx }}</el-descriptions-item>
          <el-descriptions-item label="担保方式">{{ viewData.dbfsm }}</el-descriptions-item>
          <el-descriptions-item label="信贷类型">{{ viewData.dklxm }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{ viewData.username }}</el-descriptions-item>
          <el-descriptions-item label="联系方式" :span="3">{{ viewData.phone }}</el-descriptions-item>
          <el-descriptions-item v-if="viewData.suggest" label="金融机构审核意见" :span="3">
            {{ viewData.suggest }}
          </el-descriptions-item>
          <el-descriptions-item v-if="viewData.creditSuggest" label="金融机构授信意见" :span="3">
            {{ viewData.creditSuggest }}
          </el-descriptions-item>
          <el-descriptions-item v-if="viewData.qyCreditSuggest" label="企业意见" :span="3">
            {{ viewData.qyCreditSuggest }}
          </el-descriptions-item>
          <el-descriptions-item v-if="viewData.yhFinishSuggest" label="银行意见" :span="3">
            {{ viewData.yhFinishSuggest }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </template>
      <!-- 已取消提示 -->
      <div v-if="viewData.status == 0" class="cancel-tip">
        <span class="cancel-icon">
          <i class="el-icon-close"></i>
        </span>
        <span>当前订单已取消</span>
      </div>
    <!-- 取消订单原因展示 (type==3, status==0) -->
    <div v-if="type === 3" class="detail-card">
      <div class="card-title">
        <span class="title-bar"></span>
        取消订单原因
      </div>
      <div class="cancel-reason">
        {{ viewData.qxddyy || '无' }}
      </div>
    </div>
        <!-- 取消订单表单 (type==2) -->
    <div v-if="type === 2" class="detail-card">
      <div class="card-title">
        <span class="title-bar"></span>
        取消订单
      </div>
      <div class="cancel-form">
        <div class="form-label">取消订单原因：</div>
        <el-input
          v-model="cancelReason"
          type="textarea"
          :rows="4"
          placeholder="请输入取消原因"
          clearable
          maxlength="300"
          show-word-limit
        />
        <div class="form-actions">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submitCancel">确 定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cancelAproductOrder } from "./viewApi";

export default {
  name: "orderDetails",
  props: ['show', 'title', 'viewData', 'type'],
  data() {
    return {
      cancelReason: '',
      baseSteps: [
        { label: '提交申请', key: 'start' },
        { label: '金融机构审核', key: 'audit' },
        { label: '授信', key: 'credit' },
        { label: '授信确认', key: 'confirm' },
        { label: '撮合成功(已完成)', key: 'match' },
      ],
    }
  },
  computed: {
    /** 根据订单状态生成进度步骤 */
    progressSteps() {
      const status = this.viewData.status
      const total = this.baseSteps.length
      // doneIdx: 最后完成的节点索引；failIdx: 失败的节点索引（-1表示无失败）
      const stepMap = {
        1: { doneIdx: 0, failIdx: -1 },           // 待审核：提交申请完成
        2: { doneIdx: 0, failIdx: 1 },            // 审核不通过：提交申请完成，金融机构审核失败
        3: { doneIdx: 1, failIdx: -1 },           // 授信中：提交申请+金融机构审核完成
        4: { doneIdx: 2, failIdx: -1 },           // 授信待确认：提交申请+金融机构审核+授信完成
        5: { doneIdx: 1, failIdx: 2 },            // 金融机构授信不通过：提交申请+金融机构审核完成，授信失败
        6: { doneIdx: 3, failIdx: -1 },           // 同意授信：提交申请+金融机构审核+授信+授信确认完成
        7: { doneIdx: 2, failIdx: 3 },            // 企业不同意授信：提交申请+金融机构审核+授信完成，授信确认失败
        8: { doneIdx: 4, failIdx: -1 },           // 撮合成功：全部完成
      }
      const current = stepMap[status]
      if (!current) {
        return this.baseSteps.map(s => ({ ...s, status: 'pending' }))
      }
      return this.baseSteps.map((step, idx) => {
        let statusVal = 'pending'
        if (idx <= current.doneIdx) {
          statusVal = 'done'
        } else if (idx === current.doneIdx + 1 && current.failIdx === -1) {
          statusVal = 'current'
        }
        if (idx === current.failIdx) {
          statusVal = 'failed'
        }
        return { ...step, status: statusVal }
      })
    },

    /** 进度线宽度百分比 */
    progressWidth() {
      const total = this.baseSteps.length
      if (total <= 1) return '0%'
      const allDone = this.progressSteps.every(s => s.status === 'done')
      if (allDone) return 'calc(100% - 24px)'
      // 进度线末端 = 最后一个已完成/当前/失败节点的中心位置
      const lastReachedIdx = this.progressSteps.reduce((maxIdx, s, idx) => {
        return (s.status === 'done' || s.status === 'current' || s.status === 'failed') ? idx : maxIdx
      }, -1)
      if (lastReachedIdx === -1) return '0%'
      const ratio = lastReachedIdx / (total - 1)
      // 节点k中心距容器左侧 = ratio * (W - 24px) + 12px
      // active线 left=12px，宽度 = ratio * (W - 24px)
      return `calc(${ratio * 100}% - ${24 * ratio}px)`
    },
  },
  created() {
    if (this.viewData && this.viewData.id) {
      this.initStatus()
      if (this.type === 2) {
        this.cancelReason = this.viewData.qxddyy || ''
      }
    }
  },
  methods: {
    /** 初始化状态名称 */
    initStatus() {
      const statusMap = {
        0: '已取消',
        1: '待审核',
        2: '审核不通过',
        3: '授信中',
        4: '授信待确认',
        5: '金融机构授信不通过',
        6: '同意授信',
        7: '企业不同意授信',
        8: '撮合成功',
      }
      this.$set(this.viewData, 'statusName', statusMap[this.viewData.status] || '')
    },

    /** 提交取消订单 */
    async submitCancel() {
      if (!this.cancelReason) {
        this.$baseMessage('请填写取消订单原因', 'error')
        return
      }
      if (this.viewData && this.viewData.id) {
        let res = await cancelAproductOrder({ id: this.viewData.id, qxddyy: this.cancelReason })
        this.$baseMessage('已取消订单。', 'success')
        this.closeDialog(true)
      }
    },

    closeDialog(needRefresh) {
      this.$emit('closeDialog', needRefresh)
    },
  },
}
</script>

<style lang="scss" scoped>
.detail-page {
  padding: 0 0 20px 0;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 20px;
  background: #1366ec;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.85;
  }
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
}

.title-bar {
  width: 4px;
  height: 18px;
  background: #1366ec;
  border-radius: 2px;
}

.info-grid {
  display: grid;
  gap: 16px 40px;
}

.info-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
}

.info-value {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  word-break: break-all;
}

.cancel-reason {
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 取消订单表单 */
.cancel-form {
  .form-label {
    font-size: 14px;
    font-weight: 600;
    color: #000;
    margin-bottom: 12px;
  }

  .form-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 20px;
    padding: 10px 0 0 0;

    // 按钮圆润化与间距优化
    ::v-deep .el-button {
      border-radius: 20px;
      padding: 9px 24px;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.25s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(19, 102, 236, 0.25);
      }

      &:active {
        transform: translateY(0);
      }
    }

    // 默认按钮（取消/关闭）样式优化
    ::v-deep .el-button--default {
      border-color: #dcdfe6;
      color: #606266;

      &:hover {
        color: #1366ec;
        border-color: #1366ec;
        box-shadow: 0 4px 12px rgba(19, 102, 236, 0.15);
      }
    }
  }
}

/* 进度条 */
.progress-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 50px;
  margin-bottom: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.progress-steps {
  display: flex;
  align-items: flex-start;
}

.progress-step {
  display: flex;
  align-items: flex-start;
  flex: 1;
}

.step-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.step-line {
  flex: 1;
  height: 3px;
  background: #e8e8e8;
  margin-top: 12px;
  margin-left: 4px;

  &.done {
    background: #1366ec;
  }
}

.step-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #b0b0b0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 12px;
    color: #fff;
    font-weight: bold;
  }

  &.done {
    background: #1366ec;
  }

  &.failed {
    background: #f5222d;
    box-shadow: 0 0 0 6px rgba(245, 34, 45, 0.15);
  }
}

.step-label {
  margin-top: 12px;
  font-size: 14px;
  color: #b0b0b0;
  white-space: nowrap;
  font-weight: 500;

  &.done {
    color: #1366ec;
  }

  &.failed {
    color: #f5222d;
    font-weight: 600;
  }
}

/* 取消订单提示 */
.cancel-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 18px;
  background: #fff;
  border-radius: 16px;
  margin-bottom: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  font-size: 15px;
  font-weight: 500;

  .cancel-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fa8c16;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 12px;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
